module.exports = __webpack_public_path__ + "static/architect-standing-at-a-desk-with-blueprints.e1d81fa3.webp";